import { getRecordList, getMediaUrl, getImageUrl, isDataList } from '@src/utils/media-data';
import { ominStaticResPos } from '@src/services/omni-api';

const formatExternalUrl = value => {
  const url = typeof value === 'string' ? value.trim() : '';
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url.replace(/^\/\//, '')}`;
};

const DEFAULT_DOWNLOAD_CHANNELS = ['charge', 'qrcode', 'pc', 'android', 'apple', 'harmony'];
const CUSTOM_DOWNLOAD_CHANNELS = ['qrcode', 'android', 'apple'];

export const getHomeDownloadData = (defaultItems, customItems, utmSource) => {
  const result = {
    links: { charge: '', qrcode: '', pc: '', android: '', apple: '', harmony: '' }
  };

  getRecordList(defaultItems).forEach(item => {
    const channelCode = getImageUrl(item.download_channel_code);
    if (!DEFAULT_DOWNLOAD_CHANNELS.includes(channelCode)) return;

    result.links[channelCode] = getImageUrl(item.download_link?.url);
  });

  if (!utmSource) return result;
  const customItem = getRecordList(customItems).find(item => item.download_channel_code === 'utm_source' && item.utm_source === utmSource);
  const customUrl = getImageUrl(customItem?.download_link?.url);
  if (!customUrl) return result;

  CUSTOM_DOWNLOAD_CHANNELS.forEach(channel => {
    result.links[channel] = customUrl;
  });
  return result;
};

/** 按照key来格式化数据 */
const formatOmitData = res => {
  let ominData = {};
  Object.keys(ominStaticResPos).forEach(key => {
    const dataSourceId = ominStaticResPos[key].dataSources[0].dataSourceId;
    const result = res?.data?.[dataSourceId]?.result || {};
    ominData[key] = { ...result, items: getRecordList(result.items) };
  });
  // console.log('getOmniPosData', ominData);
  return ominData;
};

/** 获取活动规则弹窗数据 */
export const getActivityRuleDataOfOminData = res => {
  const ominData = formatOmitData(res);
  const item = ominData?.activityRule?.items?.[0] || {};

  return {
    title: item.title || '活动规则',
    subtitle: item.sub_title || '上线瓜分50万现金红包',
    date: item.date || '活动时间：2026年10月15日~11月15日',
    rule:
      item.rule ||
      '· 2026年10月15日公测开启后，游戏内开启福袋有机会瓜分50万现金红包。\n\n· 2026年10月15日公测开启后，游戏内开启福袋有机会瓜分50万现金红包。\n\n· 最大单个红包金额为5万元。红包可提现为现金。'
  };
};

/** 获取首页数据 */
export const getHomeDataOfOminData = (res, utmSource) => {
  const ominData = formatOmitData(res);
  const homeKvInfo = ominData?.home_kv?.items?.[0] || {};
  const home_downloadDefault = ominData?.home_downloadDefault?.items || [];
  const attentionDownloadInfo = ominData?.attentionDownload?.items?.[0] || {};

  const downloadData = getHomeDownloadData(home_downloadDefault, ominData?.home_downloadCustom?.items, utmSource);

  // home信息
  let omniDataHome = {
    // 阶段(预约期:appointment, 预下载:pre_download, 公测:beta_download)
    game_stage_config: ominData?.home_downloadStage?.items?.[0]?.game_stage_config || '',
    // 下载链接(charge:充值渠道, qrcode:扫码下载, pc:PC官包, android:安卓apk, apple:苹果渠道, harmony:鸿蒙渠道)
    down_link: downloadData.links,
    // 第五屏下载页链接
    download_page_url: formatExternalUrl(attentionDownloadInfo.url),
    kv_image: getMediaUrl(homeKvInfo.kv_image),
    kv_video: getMediaUrl(homeKvInfo.kv_video),
    slogan: getMediaUrl(homeKvInfo.slogan),
    template: homeKvInfo?.template || '',
    play_control: isDataList(homeKvInfo?.play_control) ? homeKvInfo.play_control : [],
    sub_title: getMediaUrl(homeKvInfo.sub_title),
    expansion_pack_img: getMediaUrl(homeKvInfo.play_bg_img),
    expansion_pack_video: getMediaUrl(homeKvInfo.homepage_kv)
  };

  return omniDataHome;
};

/** 获取公测活动数据 */
export const getPublicBetaDataOfOminData = res => {
  const ominData = formatOmitData(res);
  // 公测活动
  let publicBetaList = ominData?.publicBeta?.items || [];
  return publicBetaList;
};

/** 获取游戏特色数据 */
export const getCharacteristicsDataOfOminData = res => {
  const ominData = formatOmitData(res);
  // 游戏特色
  let omniDataCharacteristics = {
    list: (ominData?.characteristics?.items || []).map(item => ({
      title: item.title,
      // 背景图标题
      desc: getMediaUrl(item.desc),
      // 背景大图
      feature_img: getMediaUrl(item.feature_img),
      // 轮播预览图
      preview: getMediaUrl(item.preview),
      // 轮播预览图-选中状态
      preview_able: getMediaUrl(item.preview_able),
      // 轮播预览图-未选中状态
      preview_disable: getMediaUrl(item.preview_disable)
    }))
  };
  return omniDataCharacteristics;
};

/** 获取门派数据 */
export const getIntroducedDataOfOminData = res => {
  const ominData = formatOmitData(res);
  // 门派数据
  let introduced = ominData?.introduced?.items || [];
  return introduced;
};
